// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Audit reports hub — matches Compare / dashboard tokens */

.sr-only {
    position: absolute;
    width: 1px;
    height: 1px;
    padding: 0;
    margin: -1px;
    overflow: hidden;
    clip: rect(0, 0, 0, 0);
    white-space: nowrap;
    border: 0;
}

.audit-reports-page {
    padding-bottom: 48px;
}

.audit-reports-hero {
    margin-bottom: 24px;
    padding: 20px 22px;
    border-radius: 14px;
    border: 1px solid rgba(255, 255, 255, 0.08);
    background: linear-gradient(165deg, rgba(58, 58, 58, 0.92) 0%, rgba(34, 34, 34, 0.98) 100%);
    box-shadow: 0 8px 28px rgba(0, 0, 0, 0.22);
}

.audit-reports-hero h1 {
    margin: 0 0 8px;
    font-size: clamp(1.25rem, 2.2vw, 1.6rem);
    font-weight: 600;
    color: rgb(245, 245, 245);
}

.audit-reports-hero p {
    margin: 0;
    font-size: 0.88rem;
    line-height: 1.5;
    color: rgba(255, 255, 255, 0.48);
    max-width: 65ch;
}

.audit-reports-banner {
    margin-bottom: 20px;
    padding: 12px 16px;
    border-radius: 10px;
    border: 1px solid rgba(218, 190, 120, 0.35);
    background: rgba(192, 159, 83, 0.12);
    font-size: 0.85rem;
    color: rgba(255, 255, 255, 0.75);
}

.audit-reports-toolbar {
    display: flex;
    flex-wrap: wrap;
    gap: 12px;
    align-items: center;
    justify-content: space-between;
    margin-bottom: 18px;
}

.audit-reports-search {
    flex: 1;
    min-width: 200px;
    max-width: 360px;
    padding: 10px 14px;
    border-radius: 10px;
    border: 1px solid rgba(255, 255, 255, 0.12);
    background: rgba(0, 0, 0, 0.25);
    color: rgb(230, 230, 230);
    font-size: 0.88rem;
}

.audit-reports-search::placeholder {
    color: rgba(255, 255, 255, 0.35);
}

.audit-reports-search:focus {
    outline: none;
    border-color: rgba(192, 159, 83, 0.45);
    box-shadow: 0 0 0 2px rgba(192, 159, 83, 0.15);
}

.audit-reports-create {
    margin-bottom: 28px;
    padding: 20px 22px;
    border-radius: 14px;
    border: 1px solid rgba(255, 255, 255, 0.08);
    background: linear-gradient(180deg, rgba(52, 52, 52, 0.95) 0%, rgba(38, 38, 38, 0.98) 100%);
}

.audit-reports-create h2 {
    margin: 0 0 6px;
    font-size: 0.68rem;
    font-weight: 600;
    letter-spacing: 0.14em;
    text-transform: uppercase;
    color: rgba(255, 255, 255, 0.38);
}

.audit-reports-create p {
    margin: 0 0 14px;
    font-size: 0.8rem;
    color: rgba(255, 255, 255, 0.42);
}

.audit-reports-create-row {
    display: flex;
    flex-wrap: wrap;
    gap: 12px;
    align-items: flex-end;
}

.audit-reports-date-field {
    display: flex;
    flex-direction: column;
    gap: 4px;
}

.audit-reports-date-field span {
    font-size: 0.65rem;
    font-weight: 600;
    letter-spacing: 0.08em;
    text-transform: uppercase;
    color: rgba(255, 255, 255, 0.4);
}

.audit-reports-date-field input {
    padding: 10px 12px;
    border-radius: 8px;
    border: 1px solid rgba(255, 255, 255, 0.12);
    background: rgba(0, 0, 0, 0.25);
    color: rgb(230, 230, 230);
    font-size: 0.85rem;
}

.audit-reports-btn {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    gap: 8px;
    padding: 11px 20px;
    border-radius: 10px;
    font-size: 0.86rem;
    font-weight: 600;
    cursor: pointer;
    border: 1px solid transparent;
    transition: filter 0.15s ease, opacity 0.15s ease;
}

.audit-reports-btn:disabled {
    opacity: 0.45;
    cursor: not-allowed;
}

.audit-reports-btn--primary {
    color: rgb(34, 34, 34);
    background: linear-gradient(180deg, rgb(218, 190, 120) 0%, rgb(192, 159, 83) 100%);
    border-color: rgba(255, 255, 255, 0.1);
}

.audit-reports-btn--primary:hover:not(:disabled) {
    filter: brightness(1.05);
}

.audit-reports-btn--ghost {
    color: rgba(255, 255, 255, 0.85);
    background: rgba(255, 255, 255, 0.06);
    border-color: rgba(255, 255, 255, 0.12);
}

.audit-reports-btn--ghost:hover:not(:disabled) {
    background: rgba(255, 255, 255, 0.1);
    border-color: rgba(192, 159, 83, 0.35);
}

.audit-reports-btn--danger {
    color: rgba(255, 200, 195, 0.95);
    background: rgba(140, 50, 45, 0.25);
    border-color: rgba(180, 70, 65, 0.4);
}

.audit-reports-btn--danger:hover:not(:disabled) {
    background: rgba(160, 60, 55, 0.4);
}

.audit-reports-table-wrap {
    overflow-x: auto;
    border-radius: 12px;
    border: 1px solid rgba(255, 255, 255, 0.08);
    background: rgba(0, 0, 0, 0.2);
}

.audit-reports-table {
    width: 100%;
    min-width: 640px;
    border-collapse: collapse;
    font-size: 0.82rem;
}

.audit-reports-table th,
.audit-reports-table td {
    padding: 12px 14px;
    text-align: left;
    border-bottom: 1px solid rgba(255, 255, 255, 0.06);
}

.audit-reports-table th {
    font-size: 0.62rem;
    font-weight: 600;
    letter-spacing: 0.1em;
    text-transform: uppercase;
    color: rgba(255, 255, 255, 0.4);
    background: rgba(0, 0, 0, 0.28);
}

.audit-reports-table tbody tr:hover {
    background: rgba(255, 255, 255, 0.04);
}

.audit-reports-table-actions {
    display: flex;
    flex-wrap: wrap;
    gap: 8px;
}

.audit-reports-empty {
    padding: 36px 20px;
    text-align: center;
    border-radius: 12px;
    border: 1px dashed rgba(255, 255, 255, 0.12);
    color: rgba(255, 255, 255, 0.45);
    font-size: 0.9rem;
}

.audit-reports-meta {
    font-size: 0.75rem;
    color: rgba(255, 255, 255, 0.38);
    margin-top: 16px;
}
`, "",{"version":3,"sources":["webpack://./src/Pages/Reports/AuditReport/AuditReports.css"],"names":[],"mappings":"AAAA,2DAA2D;;AAE3D;IACI,kBAAkB;IAClB,UAAU;IACV,WAAW;IACX,UAAU;IACV,YAAY;IACZ,gBAAgB;IAChB,sBAAsB;IACtB,mBAAmB;IACnB,SAAS;AACb;;AAEA;IACI,oBAAoB;AACxB;;AAEA;IACI,mBAAmB;IACnB,kBAAkB;IAClB,mBAAmB;IACnB,2CAA2C;IAC3C,2FAA2F;IAC3F,0CAA0C;AAC9C;;AAEA;IACI,eAAe;IACf,wCAAwC;IACxC,gBAAgB;IAChB,yBAAyB;AAC7B;;AAEA;IACI,SAAS;IACT,kBAAkB;IAClB,gBAAgB;IAChB,gCAAgC;IAChC,eAAe;AACnB;;AAEA;IACI,mBAAmB;IACnB,kBAAkB;IAClB,mBAAmB;IACnB,2CAA2C;IAC3C,oCAAoC;IACpC,kBAAkB;IAClB,gCAAgC;AACpC;;AAEA;IACI,aAAa;IACb,eAAe;IACf,SAAS;IACT,mBAAmB;IACnB,8BAA8B;IAC9B,mBAAmB;AACvB;;AAEA;IACI,OAAO;IACP,gBAAgB;IAChB,gBAAgB;IAChB,kBAAkB;IAClB,mBAAmB;IACnB,2CAA2C;IAC3C,+BAA+B;IAC/B,yBAAyB;IACzB,kBAAkB;AACtB;;AAEA;IACI,gCAAgC;AACpC;;AAEA;IACI,aAAa;IACb,sCAAsC;IACtC,8CAA8C;AAClD;;AAEA;IACI,mBAAmB;IACnB,kBAAkB;IAClB,mBAAmB;IACnB,2CAA2C;IAC3C,2FAA2F;AAC/F;;AAEA;IACI,eAAe;IACf,kBAAkB;IAClB,gBAAgB;IAChB,sBAAsB;IACtB,yBAAyB;IACzB,gCAAgC;AACpC;;AAEA;IACI,gBAAgB;IAChB,iBAAiB;IACjB,gCAAgC;AACpC;;AAEA;IACI,aAAa;IACb,eAAe;IACf,SAAS;IACT,qBAAqB;AACzB;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,QAAQ;AACZ;;AAEA;IACI,kBAAkB;IAClB,gBAAgB;IAChB,sBAAsB;IACtB,yBAAyB;IACzB,+BAA+B;AACnC;;AAEA;IACI,kBAAkB;IAClB,kBAAkB;IAClB,2CAA2C;IAC3C,+BAA+B;IAC/B,yBAAyB;IACzB,kBAAkB;AACtB;;AAEA;IACI,oBAAoB;IACpB,mBAAmB;IACnB,uBAAuB;IACvB,QAAQ;IACR,kBAAkB;IAClB,mBAAmB;IACnB,kBAAkB;IAClB,gBAAgB;IAChB,eAAe;IACf,6BAA6B;IAC7B,iDAAiD;AACrD;;AAEA;IACI,aAAa;IACb,mBAAmB;AACvB;;AAEA;IACI,sBAAsB;IACtB,kFAAkF;IAClF,sCAAsC;AAC1C;;AAEA;IACI,wBAAwB;AAC5B;;AAEA;IACI,gCAAgC;IAChC,qCAAqC;IACrC,uCAAuC;AAC3C;;AAEA;IACI,oCAAoC;IACpC,sCAAsC;AAC1C;;AAEA;IACI,gCAAgC;IAChC,mCAAmC;IACnC,oCAAoC;AACxC;;AAEA;IACI,kCAAkC;AACtC;;AAEA;IACI,gBAAgB;IAChB,mBAAmB;IACnB,2CAA2C;IAC3C,8BAA8B;AAClC;;AAEA;IACI,WAAW;IACX,gBAAgB;IAChB,yBAAyB;IACzB,kBAAkB;AACtB;;AAEA;;IAEI,kBAAkB;IAClB,gBAAgB;IAChB,kDAAkD;AACtD;;AAEA;IACI,kBAAkB;IAClB,gBAAgB;IAChB,qBAAqB;IACrB,yBAAyB;IACzB,+BAA+B;IAC/B,+BAA+B;AACnC;;AAEA;IACI,qCAAqC;AACzC;;AAEA;IACI,aAAa;IACb,eAAe;IACf,QAAQ;AACZ;;AAEA;IACI,kBAAkB;IAClB,kBAAkB;IAClB,mBAAmB;IACnB,4CAA4C;IAC5C,gCAAgC;IAChC,iBAAiB;AACrB;;AAEA;IACI,kBAAkB;IAClB,gCAAgC;IAChC,gBAAgB;AACpB","sourcesContent":["/* Audit reports hub — matches Compare / dashboard tokens */\n\n.sr-only {\n    position: absolute;\n    width: 1px;\n    height: 1px;\n    padding: 0;\n    margin: -1px;\n    overflow: hidden;\n    clip: rect(0, 0, 0, 0);\n    white-space: nowrap;\n    border: 0;\n}\n\n.audit-reports-page {\n    padding-bottom: 48px;\n}\n\n.audit-reports-hero {\n    margin-bottom: 24px;\n    padding: 20px 22px;\n    border-radius: 14px;\n    border: 1px solid rgba(255, 255, 255, 0.08);\n    background: linear-gradient(165deg, rgba(58, 58, 58, 0.92) 0%, rgba(34, 34, 34, 0.98) 100%);\n    box-shadow: 0 8px 28px rgba(0, 0, 0, 0.22);\n}\n\n.audit-reports-hero h1 {\n    margin: 0 0 8px;\n    font-size: clamp(1.25rem, 2.2vw, 1.6rem);\n    font-weight: 600;\n    color: rgb(245, 245, 245);\n}\n\n.audit-reports-hero p {\n    margin: 0;\n    font-size: 0.88rem;\n    line-height: 1.5;\n    color: rgba(255, 255, 255, 0.48);\n    max-width: 65ch;\n}\n\n.audit-reports-banner {\n    margin-bottom: 20px;\n    padding: 12px 16px;\n    border-radius: 10px;\n    border: 1px solid rgba(218, 190, 120, 0.35);\n    background: rgba(192, 159, 83, 0.12);\n    font-size: 0.85rem;\n    color: rgba(255, 255, 255, 0.75);\n}\n\n.audit-reports-toolbar {\n    display: flex;\n    flex-wrap: wrap;\n    gap: 12px;\n    align-items: center;\n    justify-content: space-between;\n    margin-bottom: 18px;\n}\n\n.audit-reports-search {\n    flex: 1;\n    min-width: 200px;\n    max-width: 360px;\n    padding: 10px 14px;\n    border-radius: 10px;\n    border: 1px solid rgba(255, 255, 255, 0.12);\n    background: rgba(0, 0, 0, 0.25);\n    color: rgb(230, 230, 230);\n    font-size: 0.88rem;\n}\n\n.audit-reports-search::placeholder {\n    color: rgba(255, 255, 255, 0.35);\n}\n\n.audit-reports-search:focus {\n    outline: none;\n    border-color: rgba(192, 159, 83, 0.45);\n    box-shadow: 0 0 0 2px rgba(192, 159, 83, 0.15);\n}\n\n.audit-reports-create {\n    margin-bottom: 28px;\n    padding: 20px 22px;\n    border-radius: 14px;\n    border: 1px solid rgba(255, 255, 255, 0.08);\n    background: linear-gradient(180deg, rgba(52, 52, 52, 0.95) 0%, rgba(38, 38, 38, 0.98) 100%);\n}\n\n.audit-reports-create h2 {\n    margin: 0 0 6px;\n    font-size: 0.68rem;\n    font-weight: 600;\n    letter-spacing: 0.14em;\n    text-transform: uppercase;\n    color: rgba(255, 255, 255, 0.38);\n}\n\n.audit-reports-create p {\n    margin: 0 0 14px;\n    font-size: 0.8rem;\n    color: rgba(255, 255, 255, 0.42);\n}\n\n.audit-reports-create-row {\n    display: flex;\n    flex-wrap: wrap;\n    gap: 12px;\n    align-items: flex-end;\n}\n\n.audit-reports-date-field {\n    display: flex;\n    flex-direction: column;\n    gap: 4px;\n}\n\n.audit-reports-date-field span {\n    font-size: 0.65rem;\n    font-weight: 600;\n    letter-spacing: 0.08em;\n    text-transform: uppercase;\n    color: rgba(255, 255, 255, 0.4);\n}\n\n.audit-reports-date-field input {\n    padding: 10px 12px;\n    border-radius: 8px;\n    border: 1px solid rgba(255, 255, 255, 0.12);\n    background: rgba(0, 0, 0, 0.25);\n    color: rgb(230, 230, 230);\n    font-size: 0.85rem;\n}\n\n.audit-reports-btn {\n    display: inline-flex;\n    align-items: center;\n    justify-content: center;\n    gap: 8px;\n    padding: 11px 20px;\n    border-radius: 10px;\n    font-size: 0.86rem;\n    font-weight: 600;\n    cursor: pointer;\n    border: 1px solid transparent;\n    transition: filter 0.15s ease, opacity 0.15s ease;\n}\n\n.audit-reports-btn:disabled {\n    opacity: 0.45;\n    cursor: not-allowed;\n}\n\n.audit-reports-btn--primary {\n    color: rgb(34, 34, 34);\n    background: linear-gradient(180deg, rgb(218, 190, 120) 0%, rgb(192, 159, 83) 100%);\n    border-color: rgba(255, 255, 255, 0.1);\n}\n\n.audit-reports-btn--primary:hover:not(:disabled) {\n    filter: brightness(1.05);\n}\n\n.audit-reports-btn--ghost {\n    color: rgba(255, 255, 255, 0.85);\n    background: rgba(255, 255, 255, 0.06);\n    border-color: rgba(255, 255, 255, 0.12);\n}\n\n.audit-reports-btn--ghost:hover:not(:disabled) {\n    background: rgba(255, 255, 255, 0.1);\n    border-color: rgba(192, 159, 83, 0.35);\n}\n\n.audit-reports-btn--danger {\n    color: rgba(255, 200, 195, 0.95);\n    background: rgba(140, 50, 45, 0.25);\n    border-color: rgba(180, 70, 65, 0.4);\n}\n\n.audit-reports-btn--danger:hover:not(:disabled) {\n    background: rgba(160, 60, 55, 0.4);\n}\n\n.audit-reports-table-wrap {\n    overflow-x: auto;\n    border-radius: 12px;\n    border: 1px solid rgba(255, 255, 255, 0.08);\n    background: rgba(0, 0, 0, 0.2);\n}\n\n.audit-reports-table {\n    width: 100%;\n    min-width: 640px;\n    border-collapse: collapse;\n    font-size: 0.82rem;\n}\n\n.audit-reports-table th,\n.audit-reports-table td {\n    padding: 12px 14px;\n    text-align: left;\n    border-bottom: 1px solid rgba(255, 255, 255, 0.06);\n}\n\n.audit-reports-table th {\n    font-size: 0.62rem;\n    font-weight: 600;\n    letter-spacing: 0.1em;\n    text-transform: uppercase;\n    color: rgba(255, 255, 255, 0.4);\n    background: rgba(0, 0, 0, 0.28);\n}\n\n.audit-reports-table tbody tr:hover {\n    background: rgba(255, 255, 255, 0.04);\n}\n\n.audit-reports-table-actions {\n    display: flex;\n    flex-wrap: wrap;\n    gap: 8px;\n}\n\n.audit-reports-empty {\n    padding: 36px 20px;\n    text-align: center;\n    border-radius: 12px;\n    border: 1px dashed rgba(255, 255, 255, 0.12);\n    color: rgba(255, 255, 255, 0.45);\n    font-size: 0.9rem;\n}\n\n.audit-reports-meta {\n    font-size: 0.75rem;\n    color: rgba(255, 255, 255, 0.38);\n    margin-top: 16px;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
